import { requestApi } from "../funcitons";

export const CellsQueries = {
    create: async (pageId, cellType) => {
        const res = await requestApi('cells', 'POST', { name: cellType, type: cellType, index: 0, page_id: pageId });
        return res.data;
    },
    update: async (cellId, data) => {
        const res = await requestApi('cells/' + cellId, 'PUT', data);
        return res.data;
    },
    updatePositionAndSize: async (cellId, cellType, position, size) => {
        const data = {
            type: cellType,
            position_x: Math.round(position.x),
            position_y: Math.round(position.y),
        };
        if (size) {
            data.size_x = Math.round(size.width);
            data.size_y = Math.round(size.height);
        }
        const res = await requestApi('cells/' + cellId, 'PUT', data);
        return res.data;
    },
    delete: async (cellId) => {
        const res = await requestApi('cells/' + cellId, 'DELETE');
        return res.data;
    },
};